import getExercisePropertyData from './getExercisePropertyData'
import getCombinedExercisesData from './getCombinedExercisesData'

/**
 * Convert trainings exercises properties data into training properties
 *
 * @param exercises
 * @returns {[]}
 */
export default function getTrainingProperties(entry, t, type) {
  if (!entry) return null
  const data = []
  const exercises =
    type === 'trainingDetail' ? getCombinedExercisesData(entry) : entry.exercises ? entry.exercises : entry

  if (!exercises[0]) return false

  if (type === 'trainingDetail') {
    data.ageCategories = getTrainingAgeCategories(entry.exercises ? entry.exercises : entry)
    data.playersMinimum = getTrainingPlayersMinimum(entry.exercises ? entry.exercises : entry)
    data.playersMaximum = getTrainingPlayersMaximium(entry.exercises ? entry.exercises : entry)
    data.fieldSizeCategory = getTrainingFieldSizeCategory(exercises)
    data.exerciseDuration = getTrainingExerciseDuration(exercises, entry)
    data.exerciseDurationList = getTrainingsExerciseDurations(exercises, entry)
  } else if (type === 'trainingBlock') {
    data.ageCategories = getTrainingAgeCategories(entry.exercises ? entry.exercises : entry)
    data.playersMinimum = getTrainingPlayersMinimum(entry.exercises ? entry.exercises : entry)
    data.playersMaximum = getTrainingPlayersMaximium(entry.exercises ? entry.exercises : entry)
    data.fieldSizeCategory = getTrainingFieldSizeCategory(exercises)
  } else {
    data.ageCategories = getTrainingAgeCategories(entry.exercises ? entry.exercises : entry)
    data.playersMinimum = entry.playersMinimum ? entry.playersMinimum : false
    data.playersMaximum = entry.playersMaximum ? entry.playersMaximum : false
    data.fieldSizeCategory = entry.fieldSizeCategory ? entry.fieldSizeCategory : false
  }

  return getExercisePropertyData(data, t, type)
}

function getTrainingAgeCategories(exercises) {
  const ageCategories = []

  // Get all age groups in array
  for (const key in exercises) {
    exercises[key]?.ageCategories?.forEach((ageGroup) => {
      ageCategories.push(ageGroup)
    })
  }

  // Filter out duplicate age groups
  return Array.from(new Set(ageCategories.map(JSON.stringify))).map(JSON.parse)
}

function getTrainingPlayersMinimum(exercises) {
  let minPlayerCountExerciseIndex = 0
  let minPlayerCountValue = 0
  let playersMinimum = 0

  for (const key in exercises) {
    const currentMinPlayerCountValue = exercises[key]?.exerciseContent[0]?.currentMinPlayerCountValue
    if (currentMinPlayerCountValue > minPlayerCountValue) {
      minPlayerCountValue = currentMinPlayerCountValue
      minPlayerCountExerciseIndex = key
    }
  }

  playersMinimum = exercises[minPlayerCountExerciseIndex]?.exerciseContent[0]?.playersMinimum

  return playersMinimum >= 1 ? playersMinimum : false
}

function getTrainingPlayersMaximium(exercises) {
  let maxPlayerCountExerciseIndex = 0
  let maxPlayerCountValue = 0
  let playersMaximum = 0

  for (const key in exercises) {
    const currentMaxPlayerCountValue = exercises[key]?.exerciseContent[0]?.currentMaxPlayerCountValue
    if (currentMaxPlayerCountValue > maxPlayerCountValue) {
      maxPlayerCountValue = currentMaxPlayerCountValue
      maxPlayerCountExerciseIndex = key
    }
  }

  playersMaximum = exercises[maxPlayerCountExerciseIndex]?.exerciseContent[0]?.playersMaximum

  return playersMaximum >= 1 ? playersMaximum : false
}

function getTrainingFieldSizeCategory(exercises) {
  let maxFieldSizeExerciseIndex = 0
  let maxFieldSizeValue = 0

  for (const key in exercises) {
    const currentMaxFieldSizeValue = exercises[key]?.exerciseContent[0]?.fieldSizeCategory[0]?.fieldSizeValue
    if (currentMaxFieldSizeValue > maxFieldSizeValue) {
      maxFieldSizeValue = currentMaxFieldSizeValue
      maxFieldSizeExerciseIndex = key
    }
  }

  return exercises[maxFieldSizeExerciseIndex]?.exerciseContent[0]?.fieldSizeCategory
}

function getTrainingExerciseDuration(exercises, entry) {
  let maxDurationValue = 0

  for (const key in exercises) {
    const customDurationsObj = []
    if (entry?.exerciseCustomDuration) {
      entry?.exerciseCustomDuration?.forEach((customDuration) => {
        if (parseInt(customDuration?.exercise[0].id) === parseInt(exercises[key].id)) {
          customDurationsObj[0] = customDuration.duration ? parseInt(customDuration?.duration) : 0
        }
      })
    }

    if (customDurationsObj[0]) {
      maxDurationValue = maxDurationValue + customDurationsObj[0]
    } else {
      if (exercises[key]?.exerciseContent[0]?.exerciseDuration) {
        maxDurationValue = maxDurationValue + exercises[key]?.exerciseContent[0]?.exerciseDuration
      }
    }
  }

  return maxDurationValue
}

function getTrainingsExerciseDurations(exercises, entry) {
  const exercisesDurationList = []

  for (const key in exercises) {
    const customDurationsObj = []
    if (entry?.exerciseCustomDuration) {
      entry?.exerciseCustomDuration?.forEach((customDuration) => {
        if (parseInt(customDuration?.exercise[0].id) === parseInt(exercises[key].id)) {
          customDurationsObj[0] = customDuration.duration ? parseInt(customDuration?.duration) : 0
        }
      })
    }

    if (customDurationsObj[0]) {
      exercisesDurationList[parseInt(exercises[key].id)] = customDurationsObj[0]
    } else if (exercises[key]?.exerciseContent[0]?.exerciseDuration) {
      exercisesDurationList[parseInt(exercises[key].id)] = exercises[key]?.exerciseContent[0]?.exerciseDuration
    } else {
      exercisesDurationList[parseInt(exercises[key].id)] = 0
    }
  }

  return exercisesDurationList
}
